import React from 'react';
import {Routes, Route} from 'react-router-dom';
import HomePage from './pages/HomePage'; // Добавлено расширение и полный путь
import PostPage from './pages/PostPage';
import Layout from './components/Layout/Layout';
import CreatePostPage from "./pages/CreatePostPage";
import LoginPage from "./pages/LoginPage";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import {AuthProvider} from './contexts/AuthContext'; // Полный путь
import ContactPage from "./pages/ContactPage";
import AboutPage from "./pages/AboutPage";
import NotFoundPage from "./pages/NotFoundPage";
import PostCreatedPage from "./pages/PostCreatedPage";
import AuthorPage from "./pages/AuthorPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import EditPostPage from "./pages/EditPostPage";
import SecretPage from "./pages/SecretPage";
import ProsafetyRedirectPage from "./pages/ProsafetyRedirectPage";
import PrinciplesPage from "./pages/proSafety/Principles";

// Указываем тип функционального компонента
const App: React.FC = () => {
    return (
        <AuthProvider>
            <Routes>
                <Route path="/" element={<Layout><HomePage/></Layout>}/>
                <Route path="/post/:id" element={<Layout><PostPage/></Layout>}/>
                <Route path="/login" element={<Layout><LoginPage/></Layout>}/>
                <Route path="/contact" element={<Layout><ContactPage/></Layout>}/>
                <Route path="/about" element={<Layout><AboutPage/></Layout>}/>
                <Route path="/post-created" element={<Layout><PostCreatedPage/></Layout>}/>
                <Route path="/author/:id" element={<Layout><AuthorPage/></Layout>}/>
                <Route path="/privacy-policy" element={<Layout><PrivacyPolicyPage/></Layout>}/>
                <Route path="/specially_for_you" element ={<Layout><SecretPage/></Layout>}/>
                <Route path="/prosafety" element={<ProsafetyRedirectPage/>} />
                <Route path="/principles" element={<PrinciplesPage />} />
                <Route
                    path="/edit-post/:postId"
                    element={
                        <ProtectedRoute>
                            <Layout><EditPostPage/></Layout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/create_post"
                    element={
                        <ProtectedRoute>
                            <Layout><CreatePostPage/></Layout>
                        </ProtectedRoute>
                    }
                />
                <Route path="*" element={<Layout><NotFoundPage/></Layout>}/>
            </Routes>
        </AuthProvider>
    );
};

export default App;